import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

const borderedBoxStyle = {
  border: '4px solid #E5E5E5',
  backgroundColor: '#FFFFFF',
  borderRadius: '8px',
  p: { xs: 2, lg: 2, xl: 3 },
};

const BoxContainer = ({ children, gap = 3, id = 'BOX-CONTAINER' }) => {
  const theme = useTheme();

  // Llamamos hooks para breakpoints específicos que necesitemos
  const matchesXs = useMediaQuery(theme.breakpoints.up('xs'));
  const matchesSm = useMediaQuery(theme.breakpoints.up('sm'));
  const matchesMd = useMediaQuery(theme.breakpoints.up('md'));
  const matchesLg = useMediaQuery(theme.breakpoints.up('lg'));
  const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));

  const isChildVisible = child => {
    if (!child || (typeof child === 'string' && child.trim() === ''))
      return false;

    const sx = child?.props?.sx || {};
    const style = child?.props?.style || {};

    if (style.display === 'none') return false;

    if (sx.display) {
      if (typeof sx.display === 'string' && sx.display === 'none') return false;
      // Solo soporte básico para objetos de display
      if (typeof sx.display === 'object') {
        if (sx.display.xs === 'none' && matchesXs) return false;
        if (sx.display.sm === 'none' && matchesSm) return false;
        if (sx.display.md === 'none' && matchesMd) return false;
        if (sx.display.lg === 'none' && matchesLg) return false;
        if (sx.display.xl === 'none' && matchesXl) return false;
      }
    }

    return true;
  };

  const validChildren = React.Children.toArray(children).filter(isChildVisible);

  if (validChildren.length === 0) return null;

  return (
    <Box
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap,
        width: '100%',
        bgcolor: '#F6F6F6',
      }}
    >
      {validChildren.map((child, index) => {
        const sxExtra = child?.props?.sxExtra || {};
        const childName =
          child?.type?.name || child?.type?.displayName || `Child-${index}`;

        return (
          <Box
            id={`${id}-ITEM-${childName.toUpperCase()}`}
            key={`${id}-${index}-ITEM-${childName.toUpperCase()}`}
            sx={{ ...borderedBoxStyle, ...sxExtra }}
          >
            {child}
          </Box>
        );
      })}
    </Box>
  );
};

export default BoxContainer;
